export default "__VITE_ASSET__BMMfO3yl__"